module.exports = __webpack_public_path__ + "static/media/mdi_tick-circle-outline.da1b362b.svg";